import { call, put, takeEvery } from "redux-saga/effects"
import { getCustomizeOrderError, getCustomizeOrderSuccess, updateCustomizeOrderError, updateCustomizeOrderSuccess } from "./actions"
import { AppConfiguration } from "config";
import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper";
import { GET_CUSTOMIZE_ORDER, UPDATE_CUSTOMIZE_ORDER } from "./actionTypes";

function* onGetCustomizeOrder(action) {
  const page_name = action?.payload?.page_name
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/customize_orders`,
      action?.payload,
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCustomizeOrderSuccess(response))
  } catch (error) {
    yield put(getCustomizeOrderError(error))
  }
}

function* onUpdateCustomizeOrder(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/customize_orders/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(updateCustomizeOrderSuccess(response, action.payload.component))
  } catch (error) {
    yield put(updateCustomizeOrderError(error))
  }
}

function* CustomizeOrderSaga() {
  yield takeEvery(GET_CUSTOMIZE_ORDER, onGetCustomizeOrder);
  yield takeEvery(UPDATE_CUSTOMIZE_ORDER, onUpdateCustomizeOrder);
}

export default CustomizeOrderSaga;
